import { ReactComponent as CoinsBambooLogoSmall } from "./logo-small.svg";

const LogoSmall: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <CoinsBambooLogoSmall {...props} />;

export default LogoSmall;
